import config from 'libs/config';

import LicenseController from '@/controller/licensecontroller.js';
const controller = new LicenseController();

const hashVal = 'hsh';
const storeKey = 'lcs';


export function GetModules() {
  let storageValue = localStorage.getItem(storeKey);
  if (storageValue == null) return null;

  return JSON.parse(storageValue);
}

export async function CheckModules() {
  if (config.isDebug) {
    if(window.lc == null){
      window.lc = await controller.GetProductCode();
    }
  }

  let sessionHsh = localStorage.getItem(storeKey);
  if (sessionHsh == null) {
    await GetAndPersistModules();
    return GetModules();
  } else {
    let hasChanged = LicenseHashChanged();
    if (hasChanged) {
      await GetAndPersistModules();
    }
    return GetModules();
  }
}

export async function GetAndPersistModules() {
  let lcs = await modules();

  lcs[hashVal] = window.lc;
  window.localStorage.setItem(storeKey, JSON.stringify(lcs));
  return lcs;
}

function LicenseHashChanged() {
  let modules = JSON.parse(localStorage.getItem(storeKey));

  var changed = modules[hashVal] !== window.lc;

  return changed;
}

async function modules() {
  return controller.Retrieve();
}

//LicenseController
export const Modules = {
  Relations_CRM: 'Relations_CRM',
  WorkFlow: 'WorkFlow',
  WorkFlow_Contract: 'WorkFlow_Contract',
  WorkFlow_SLA: 'WorkFlow_SLA',
  WorkFlow_PreCalc: 'WorkFlow_PreCalc',
  WorkFlow_Planning: 'WorkFlow_Planning',
  WorkFlow_PresenceReg: 'WorkFlow_PresenceReg',
  WorkFlow_Realization: 'WorkFlow_Realization',
  WorkFlow_DashBoard: 'WorkFlow_DashBoard',
  WorkFlow_Mail: 'WorkFlow_Mail',
  WorkFlow_RepeatingOrders: 'WorkFlow_RepeatingOrders',
  OverhaulOrders: 'OverhaulOrders',
  ObjectsAndLocations: 'ObjectsAndLocations',
  ObjectsAndLocations_ObjectAndLocationTypes:
    'ObjectsAndLocations_ObjectAndLocationTypes',
  ObjectsAndLocations_MI_PreCalc: 'ObjectsAndLocations_MI_PreCalc',
  ObjectsAndLocations_MI_MIPlan: 'ObjectsAndLocations_MI_MIPlan',
  ObjectsAndLocations_MI_MeasuringDevice:
    'ObjectsAndLocations_MI_MeasuringDevice',
  ObjectsAndLocations_MultipleYearPlan: 'ObjectsAndLocations_MultipleYearPlan',
  ObjectsAndLocations_MeterPositions: 'ObjectsAndLocations_MeterPositions',
  ObjectsAndLocations_Depreciation: 'ObjectsAndLocations_Depreciation',
  Projects: 'Projects',
  Projects_Invoice: 'Projects_Invoice',
  Orders: 'Orders',
  Orders_RMA: 'Orders_RMA',
  Orders_PriceList: 'Orders_PriceList',
  Orders_RegionPrice: 'Orders_RegionPrice',
  Orders_OrderAndTransportCost: 'Orders_OrderAndTransportCost',
  Invoice: 'Invoice',
  HourRegistration: 'HourRegistration',
  HourRegistration_WorkableDay: 'HourRegistration_WorkableDay',
  Articles: 'Articles',
  Articles_Composed: 'Articles_Composed',
  Articles_CrossLink: 'Articles_CrossLink',
  Articles_Alternative: 'Articles_Alternative',
  Articles_Purchase: 'Articles_Purchase',
  Articles_Stock: 'Articles_Stock',
  Articles_Purchase_Rental: 'Articles_Purchase_Rental',
  AccessSecurity_AccessRole: 'AccessSecurity_AccessRole',
  AccessSecurity_Fiat: 'AccessSecurity_Fiat',
  AccessSecurity_AdministrationAccess: 'AccessSecurity_AdministrationAccess',
  Import: 'Import',
  Extra_MultipleLanguage_Report: 'Extra_MultipleLanguage_Report',
  Extra_MultipleLanguage_Database: 'Extra_MultipleLanguage_Database',
  Extra_Competence: 'Extra_Competence',
  AutoNumbering: 'AutoNumbering'
};
